// Dependencies
import styled, { css } from 'styled-components';

//Components
import { Typography } from '../../../display/Typography';
import { ArrowBottom } from '../../../../assets/icons/ArrowBottom';

// Types
import { InputSizeTypes, TypeDropDown } from './types';

type ContainerProps = {
  typeDropDown: TypeDropDown;
  labelText: boolean;
  inputSize: InputSizeTypes;
};

type HeaderProps = {
  typeDropDown: TypeDropDown;
  isActive: boolean;
  borderError?: boolean;
  isDisabled?: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxxs};
  cursor: pointer;
  width: 100%;
  ${({ inputSize }) =>
    ({
      XXL: css`
        width: 38rem;
      `,
      XL: css`
        width: 35rem;
      `,
      L: css`
        width: 27rem;
      `,
      M: css`
        width: 22rem;
      `,
      S: css`
        width: 17rem;
      `,
      XS: css`
        width: 10rem;
      `,
    })[inputSize]};

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    ${({ inputSize }) =>
      ({
        XXL: css`
          width: 100%;
          max-width: 38rem;
        `,
        XL: css`
          width: 100%;
          max-width: 35rem;
        `,
        L: css`
          width: 100%;
          max-width: 27rem;
        `,
        M: css`
          width: 100%;
          max-width: 22rem;
        `,
        S: css`
          width: 100%;
          max-width: 17rem;
        `,
        XS: css`
          width: 100%;
          max-width: 10rem;
        `,
      })[inputSize]};
  }

  // width: ${(props) => props.typeDropDown === 'Table' && '100%'};
`;

export const Label = styled(Typography)`
  white-space: nowrap;
  font-size: ${({ theme }) => theme.fontSize.S};
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

export const DropDownContainer = styled.div``;

export const DropDownHeader = styled.div<HeaderProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xxxs};
  padding: 0 0.8rem 0 1rem;
  height: 4rem;
  border-radius: 0.5rem;
  background: ${({ theme }) => theme.colors.white};
  border: 0.1rem solid ${({ theme }) => theme.colors.black};
  overflow: hidden;

  ${(props) =>
    props.isActive &&
    css`
      outline: 0.08rem solid ${({ theme }) => theme.colors.black};
      ${SelectedOption} {
        text-shadow: 0 0 1px;
      }
    `}

  ${(props) =>
    props.typeDropDown === 'Table' &&
    css`
      border: none;
      outline: none;
      background: initial;
    `};

  ${(props) =>
    props.isDisabled &&
    css`
      background: ${({ theme }) => theme.colors.greyLight};
      border: none;
      ${SelectedOption} {
        font-weight: ${({ theme }) => theme.fontWeight.medium};
        color: ${({ theme }) => theme.colors.greyDark};
      }
    `};

  ${(props) =>
    props.borderError &&
    css`
      border: 0.1rem solid ${({ theme }) => theme.colors.lightCoralRed};
    `};

  &:focus {
    outline: 0.08rem solid ${({ theme }) => theme.colors.black};
  }
`;

export const SelectedOption = styled(Typography)`
  font-size: ${({ theme }) => theme.fontSize.S};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

export const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0.4rem;
  margin: 0;
  flex-shrink: 0;
`;

export const ArrowDown = styled(ArrowBottom)`
  path {
    fill: ${({ theme }) => theme.colors.black};
  }
  vertical-align: middle;
  min-width: 1.3rem;
  min-height: 0.9rem;
  flex-shrink: 0;
`;
